import React from 'react';
import { formatKm, formatMinutes, formatPct, orderIdsOfStop } from '../lib/logisticsUi';

function stopLabel(stop) {
  return stop.stop_type === 'delivery' ? 'Delivery' : 'Pickup';
}

function RoutePreviewMap({ route, compact = false, tripId, onSkipStop, skippingId }) {
  if (!route) {
    return (
      <div className="orders-placeholder">
        <p>Select a cluster to preview a stop sequence.</p>
      </div>
    );
  }

  const stops = route.stops || [];
  const warning = route.warning === 'high_detour' || route.warning?.code === 'high_detour';

  return (
    <div className={`route-preview ${compact ? 'route-preview-compact' : ''}`}>
      <div className="route-preview-stats">
        <div>
          <span>Planned</span>
          <strong>{formatKm(route.planned_distance_km)}</strong>
        </div>
        <div>
          <span>Saved</span>
          <strong>{formatKm(route.savings_km)}</strong>
        </div>
        <div>
          <span>Duration</span>
          <strong>{formatMinutes(route.planned_duration_min)}</strong>
        </div>
        <div>
          <span>Fill</span>
          <strong>{formatPct(route.utilization)}</strong>
        </div>
      </div>
      {warning && (
        <div className="dispatch-banner dispatch-banner-warn">
          Detour is high compared with dedicated trips. Review before assigning.
        </div>
      )}
      <ol className="route-timeline">
        {stops.map((stop) => {
          const ids = orderIdsOfStop(stop);
          const done = stop.status === 'done' || stop.status === 'confirmed';
          const current = stop.status === 'arrived' || stop.status === 'pending';
          return (
            <li
              key={`${stop.seq}-${stop.stop_type}-${stop.locality}`}
              className={[
                'route-timeline-item',
                done ? 'is-done' : '',
                !done && current && stop.status === 'arrived' ? 'is-current' : '',
              ].filter(Boolean).join(' ')}
            >
              <span className="route-timeline-seq">{stop.seq}</span>
              <div className="route-timeline-body">
                <p className="route-timeline-title">
                  {stopLabel(stop)} · {stop.locality || '—'}
                </p>
                <p className="route-timeline-meta">
                  {stop.eta ? `ETA ${stop.eta}` : 'ETA —'}
                  {ids.length ? ` · Orders ${ids.map((id) => `#${id}`).join(', ')}` : ''}
                  {stop.status && stop.status !== 'pending' ? ` · ${stop.status}` : ''}
                </p>
                {onSkipStop && tripId && stop.trip_stop_id && stop.status !== 'done' && stop.status !== 'skipped' ? (
                  <button
                    type="button"
                    className="timeline-skip-btn"
                    disabled={skippingId === stop.trip_stop_id}
                    onClick={() => onSkipStop(tripId, stop.trip_stop_id)}
                  >
                    Skip stop
                  </button>
                ) : null}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}

export default RoutePreviewMap;
